import { Paper } from '@mantine/core'
import { Outlet } from 'react-router'
import { BaseLayout } from '../BaseLayout/BaseLayout'
import { HomeNavLinks } from './HomeNavLinks'

export const HomeLayout = () => {
  return (
    <BaseLayout
      navSection={
        <Paper p={8}>
          <HomeNavLinks />
        </Paper>
      }
    >
      <Outlet />
    </BaseLayout>
  )
}
